import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m28.89 12.436 14.54 9.087a3.34 3.34 0 0 1-.002 5.667L28.87 36.276a2.863 2.863 0 0 1-4.363-2.111c-.34-3.057-.51-6.307-.508-9.748.003-3.461.179-6.752.528-9.872a2.863 2.863 0 0 1 4.364-2.11Zm-20.999 0 14.539 9.087a3.34 3.34 0 0 1-.002 5.667L7.87 36.276a2.864 2.864 0 0 1-4.362-2.111c-.341-3.057-.51-6.307-.508-9.748.002-3.461.178-6.752.528-9.872a2.864 2.864 0 0 1 4.363-2.11Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFastForwardFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FastForwardFilled_default = SvgFastForwardFilled;

export { FastForwardFilled_default as default };
